import defaultClient from '@/plugins/axios/defaultClient'

export default {
  putWithdrawalAccount(uuid, account) {
    return defaultClient.put(`/withdrawal-accounts/${uuid}/`, account)
  },
  postWithdrawalAccountVerifyWithdrawalAccount(uuid, verifyWord) {
    return defaultClient.post(`/withdrawal-accounts/${uuid}/verify/`, { verifyWord })
  },
}
